// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import summaryApi from "../common/Api";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { GoSearch } from "react-icons/go";
import { RiCloseLargeFill } from "react-icons/ri";
import { toast } from "react-toastify";
import Role from "./../common/Role";
import Loading from "./../components/loading/loading";

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchAllUsers = async () => {
    const tokenApi = Cookies.get("tokenApi");
    try {
      const response = await axios.get(summaryApi.users.url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });
      // console.log("response", response);
      setUsers(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const editUser = async (user) => {
    const tokenApi = Cookies.get("tokenApi");
    try {
      await axios({
        url: summaryApi.editUser(user._id).url,
        method: summaryApi.editUser(user._id).method,
        data: user,
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });

      fetchAllUsers();
      toast.success("User updated successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setPopup(true);
  };

  const handleDeleteUser = async (userId) => {
    const tokenApi = Cookies.get("tokenApi");
    try {
      await axios({
        url: summaryApi.deleteUser(userId).url,
        method: summaryApi.deleteUser(userId).method,
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });

      fetchAllUsers();

      toast.success("User deleted successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(selectedUser);
    setPopup(false);
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const filteredUsers = users?.filter((user) =>
    user?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="relative p-4">
      <div className="flex justify-between items-center mb-4">
        <h2
          style={{ fontFamily: "serif" }}
          className="font-semibold text-xl uppercase "
        >
          All Users:
        </h2>
        <div className="flex items-center w-[400px] relative">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="Search by email"
            className="border-2 border-gray-300 shadow-sm rounded-full p-2 px-4 w-full outline-none h-[35px] transition-all hover:shadow-md"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="bg-main-background w-10 h-[35px] rounded-r-full absolute right-0 flex items-center justify-center">
            <span className="text-white">
              <GoSearch />
            </span>
          </div>
        </div>
      </div>
      <table className="w-full border-collapse text-center">
        <thead>
          <tr>
            <th className="border p-2 bg-gray-200">Sr.</th>
            <th className="border p-2 bg-gray-200">Name</th>
            <th className="border p-2 bg-gray-200">Email</th>
            <th className="border p-2 bg-gray-200">Role</th>
            <th className="border p-2 bg-gray-200">Created At</th>
            <th className="border p-2 bg-gray-200">Action</th>
          </tr>
        </thead>
        <tbody
          style={{ maxHeight: "calc(100vh - 250px)" }}
          className=" md:w-[95%] py-2 overflow-auto  overflow-x-hidden max-h-[calc(100vh - 250px)] sm:max-h-[300px] md:max-h-[400px] lg:max-h-[calc(100vh-500px)] xl:max-h-[100vh]"
        >
          {/* <div > */}
          {filteredUsers?.map((user, index) => (
            <tr key={index}>
              <td className="border p-2">{index + 1}</td>
              <td className="border p-2">{user?.username}</td>
              <td className="border p-2">{user?.email}</td>
              <td className="border p-2">{user?.role}</td>
              <td className="border p-2">
                {moment(user?.createdAt).format("LLL")}
              </td>
              <td className="border p-2">
                <button
                  className="bg-red-500 text-white p-2 rounded-full mr-2"
                  onClick={() => handleDeleteUser(user._id)}
                >
                  <MdDelete />
                </button>
                <button
                  className="bg-blue-500 text-white p-2 rounded-full"
                  onClick={() => handleEditClick(user)}
                >
                  <MdModeEdit />
                </button>
              </td>
            </tr>
          ))}
          {/* </div> */}
        </tbody>
      </table>

      {popup && selectedUser && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-500">
          <div className="bg-white p-4 rounded-lg shadow-lg w-full max-w-[450px]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Edit User</h2>
              <div
                className="text-gray-500 cursor-pointer"
                onClick={() => setPopup(false)}
              >
                <span className="hover:text-red-600">
                  <RiCloseLargeFill />
                </span>
              </div>
            </div>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="mb-4 flex justify-between items-center gap-2">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="mt-1 p-2 border border-gray-300 rounded-md w-full outline-none h-[35px] transition-all"
                  value={selectedUser.username}
                  onChange={(e) =>
                    setSelectedUser({
                      ...selectedUser,
                      username: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-4 flex justify-between items-center gap-2">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="mt-1 p-2 border border-gray-300 rounded-md w-full outline-none h-[35px] transition-all"
                  value={selectedUser.email}
                  onChange={(e) =>
                    setSelectedUser({ ...selectedUser, email: e.target.value })
                  }
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="role"
                  className="block text-sm font-medium text-gray-700"
                >
                  Role
                </label>
                <select
                  id="role"
                  name="role"
                  className="mt-1 p-2 border border-gray-300 rounded-md w-full outline-none"
                  value={selectedUser.role}
                  onChange={(e) =>
                    setSelectedUser({ ...selectedUser, role: e.target.value })
                  }
                >
                  <option value="admin">{Role.ADMIN}</option>
                  <option value="user">{Role.GENERAL}</option>
                </select>
              </div>
              <div className="bg-main-background mx-auto text-white w-[80px] text-center py-1 px-1 flex items-center justify-center rounded">
                <button type="submit">Update</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllUsers;
